module.exports = __webpack_public_path__ + "img/rep.4f86dbfa.svg";